var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teasMbModulePoint" }, [
    _vm.dataItem._level == 2
      ? _c("div", { staticClass: "pointTitle" }, [
          _c("span", [_c("label", [_vm._v(_vm._s(_vm.dataItem.title))])]),
        ])
      : _c("div", { staticClass: "defaultTitle" }, [
          _c("div", { staticClass: "underdashed" }),
          _c("div", [_vm._v(_vm._s(_vm.dataItem.title))]),
        ]),
    _c(
      "div",
      {
        staticClass: "firstTypeOne-children-secondItem-list",
        class:
          _vm.dataItem.children && _vm.dataItem.children.length > 0
            ? "hasLeftBorder"
            : "",
        style: { paddingTop: (_vm.dataItem._level != 2 ? "20" : "10") + "px" },
      },
      [
        _c(
          "div",
          {
            staticClass: "firstTypeOne-children-secondItem-list-content",
            style: {
              paddingTop: (_vm.dataItem.list.length == 0 ? "0" : "13") + "px",
            },
          },
          [
            _vm._l(_vm.dataItem.list, function (secondList, secondListIndex) {
              return _c(
                "div",
                {
                  key: secondListIndex,
                  staticClass:
                    "\n          firstTypeOne-children-secondItem-list-content-item\n          list-item-grow\n        ",
                  class: {
                    noRightBorder:
                      (_vm.dataItem.list.length < 3 &&
                        secondListIndex % _vm.dataItem.list.length ==
                          _vm.dataItem.list.length - 1 &&
                        _vm.dataItem.is_total_value != "1") ||
                      secondListIndex % 3 == 2,
                    "threeItem-list-more": _vm.dataItem.list.length >= 4,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.clickItem(secondList)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "score" }, [
                    _vm._v(_vm._s(secondList.score)),
                  ]),
                  _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(secondList.title)),
                  ]),
                ]
              )
            }),
            _vm.dataItem.is_total_value == "1"
              ? _c("div", { staticClass: "list-item-grow list-item-total" }, [
                  _c("div", { staticClass: "item-total" }, [
                    _c("span", { staticClass: "totalTitle" }, [
                      _vm._v(_vm._s(_vm.dataItem.totalItem.title) + ":"),
                    ]),
                    _c("span", { staticClass: "second-score" }, [
                      _c("span", { staticClass: "score" }, [
                        _vm._v(_vm._s(_vm.dataItem.totalItem.score)),
                      ]),
                      _c("span", { staticClass: "detail" }),
                    ]),
                    _c("span", { staticClass: "text" }, [_vm._v("分")]),
                  ]),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm.dataItem.children && _vm.dataItem.children.length > 0
      ? _c(
          "div",
          { staticClass: "pointChildren" },
          _vm._l(_vm.dataItem.children, function (item, index) {
            return _c("DsfMobileTeasMbDbPointModule", {
              key: index,
              class:
                index != _vm.dataItem.children.length - 1
                  ? "hasLeftBorder"
                  : "",
              attrs: { dataItem: item },
              on: { moduleClickItem: _vm.moduleClickItem },
            })
          }),
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }